/**
 * @author chazzhou
 */

import Select from './select';

export default Select;
